<div class="cf-above order-confirmation">
  <div class="cf-form container">
    <div class="row mb-2 justify-content-md-center" *ngIf="!orderDeclined">
      <div class="col col-md-10 col-lg-12 text-md-center">
        <p class="hero-2 mb-2">Congrats! Now let’s finish up.</p>
        <p class="content-2 mb-4">
          Your business is almost official.
          Just answer a few more questions so we can send your paperwork to the state.
        </p>
        <p class="content-2 mb-0">
          See your order details below, and look for a confirmation at
          <span class="font-weight-bold">{{ checkoutEmail }}</span>.
        </p>
      </div>
    </div>
    <div class="row mb-2 justify-content-md-center" *ngIf="orderDeclined">
      <div class="col col-md-10 col-lg-12 text-md-center">
        <p class="hero-2 mb-2">We tried but couldn't process your card</p>
        <p class="content-2 mb-4">
          We saved your answers, but we couldn't file your paperwork yet because we hit a snag when we ran your card. There's no need to checkout again—just call <a class="d-md-none" href="tel:8666980052">(866) 698-0052</a><span class="d-none d-md-inline">(866) 698-0052</span> to verify your payment info or enter a new card in My Account to complete the process.
        </p>
        <p class="content-2 mb-0">
          Then, we have a few more questions to finalize your paperwork.
        </p>
      </div>
    </div>
    <div class="row justify-content-center" *ngIf="!orderDeclined">
      <div class="col">
        <div class="confetti-container">
          <img class="confetti-image" src="assets/img/confetti.svg" />
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col col-md-8 col-lg-6 col-xl-4">
        <div class="receipt-container">
          <div id="receipt-details">
            <div class="text-center mb-4" *ngIf="hasCompanyName">
              <p class="m-0 font-size-16 font-size-md-18">
                Proposed business name
              </p>
              <p class="title-2 m-0 business-name">
                {{businessName}}
              </p>
              <p class="m-0 font-size-16 font-size-md-18">
                pending final name search
              </p>
            </div>
            <div class="text-center mb-4" *ngIf="!hasCompanyName">
              <p class="title-2 m-0">
                {{firstName}},
              </p>
              <p class="m-0 font-size-16 font-size-md-18">
                you’re on your way!
              </p>
            </div>
            <div class="d-flex justify-content-center mb-36 text-left">
              <div class="flex-1 column-right-border">
                <span class="caption-1 d-block light-grey">
                  Location
                </span>
                <span class="highlight-2 font-size-18 font-size-md-24">
                  {{location}}
                </span>
              </div>
              <div class="flex-1">
                <span class="caption-1 d-block pl-36 light-grey">
                  Type
                </span>
                <span class="highlight-2 pl-36 font-size-18 font-size-md-24">
                  {{type}}
                </span>
              </div>
            </div>
            <div class="text-center mb-5">
              <button id="btn-save" class="btn btn-action btn-lg w-100" (click)="save()">
                <span>Continue</span>
                <span class="continue-arrow">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" height="15" width="15">
                    <use href="assets/sprite.view.svg#glo-arrow-right"></use>
                  </svg>
                </span>
              </button>
            </div>

            <div id="line-items">
              <div class="d-flex item-header mb-4">
                <div class="flex-1 text-left content-4 mb-4">
                  Order summary
                </div>
                <div class="flex-1 text-right content-4">
                  Date: {{orderDate}}
                </div>
              </div>

              <div class="d-flex mb-4">
                <div class="flex-grow-1 text-left receipt-left-col">
                  <p class="mb-0 content-4">
                    {{ getLLCPackage() }}
                  </p>
                  <p class="mb-0 caption-1 light-grey">
                    Order #{{ orderId }}
                  </p>
                </div>
                <div class="text-right" [ngClass]="{'payment-error': orderDeclined}">
                  <span class="content-4" *ngIf="!orderDeclined">
                    {{llcAmount | currency:'USD'}}
                  </span>
                  <span class="caption-1 text-danger" *ngIf="orderDeclined">
                    Payment declined
                  </span>
                </div>
              </div>

              <div class="d-flex mb-4" *ngIf="lwtOrder && lwtOrder.ExpressOrderId">
                <div class="flex-grow-1 text-left receipt-left-col">
                  <p class="mb-0 content-4">
                    Last Will and Testament
                  </p>
                  <p class="mb-0 caption-1 light-grey">
                    Order #{{ lwtOrder.ExpressOrderId }}
                  </p>
                </div>
                <div class="text-right" [ngClass]="{'payment-error': lwtOrder.PaymentStatus === 4}">
                  <span class="content-4" *ngIf="lwtOrder.PaymentStatus === 3">
                    {{lwtAmount | currency:'USD'}}
                  </span>
                  <span class="caption-1 text-danger" *ngIf="lwtOrder.PaymentStatus === 4">
                    Payment declined
                  </span>
                </div>
              </div>

              <div class="d-flex mb-4" *ngIf="tmsOrder && tmsOrder.ExpressOrderId">
                <div class="flex-grow-1 text-left receipt-left-col">
                  <p class="mb-0 content-4">
                    Trademark Search
                  </p>
                  <p class="mb-0 caption-1 light-grey">
                    Order #{{ tmsOrder.ExpressOrderId }}
                  </p>
                </div>
                <div class="text-right" [ngClass]="{'payment-error': tmsOrder.PaymentStatus === 4}">
                  <span class="content-4" *ngIf="tmsOrder.PaymentStatus === 3">
                    {{tsmAmount | currency:'USD'}}
                  </span>
                  <span class="caption-1 text-danger" *ngIf="tmsOrder.PaymentStatus === 4">
                    Payment declined
                  </span>
                </div>
              </div>

              <div class="d-flex mb-4" *ngIf="gsuiteOrder && gsuiteOrder.ExpressOrderId">
                <div class="flex-grow-1 text-left receipt-left-col">
                  <p class="mb-0 content-4">
                    G Suite {{gsuitePackageType}}
                  </p>
                  <p class="mb-0 caption-1 light-grey">
                    Order #{{ gsuiteOrder.ExpressOrderId }}
                  </p>
                </div>
                <div class="text-right" [ngClass]="{'payment-error': gsuiteOrder.PaymentStatus === 4}">
                  <span class="content-4" *ngIf="gsuiteOrder.PaymentStatus === 3">
                    {{gsuiteAmount | currency:'USD'}}
                  </span>
                  <span class="caption-1 text-danger" *ngIf="gsuiteOrder.PaymentStatus === 4">
                    Payment declined
                  </span>
                </div>
              </div>

              <div class="order-total pt-4 d-flex mb-4" *ngIf="!orderDeclined">
                <div class="flex-grow-1 text-left receipt-left-col">
                  <p class="mb-0 content-4">
                    Order total
                  </p>
                  <p class="mb-0 caption-1 light-grey" *ngIf="isThreePay">
                    Total charged today
                  </p>
                </div>
                <div class="text-right">
                  <p class="mb-0 content-4">
                    {{orderTotal | currency:'USD'}}
                  </p>
                  <p class="mb-0 caption-1 light-grey" *ngIf="isThreePay">
                    {{chargedToday | currency:'USD'}}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row disclaimers justify-content-center" *ngIf="!orderDeclined">
      <div class="col col-md-8 col-lg-6 col-xl-4 text-left">

        <div id="three-pay-disclaimer" class="mt-4 caption-1" *ngIf="isThreePay">
          The remaining balance will be billed in two monthly installments of {{installmentAmount | currency:'USD'}}.
        </div>

        <div id="registered-agent-disclaimer" class="mt-4 caption-1" *ngIf="hasRegisteredAgent" >
          Once we file your paperwork with the state, you'll get automatically charged $249 to start Registered Agent
          Services.
          The service auto-renews annually and will be billed to your card on file. The renewal rate is subject to
          change.
          No longer need it? Go online or call (844) 962-7490. You'll need to complete extra steps to change your RA
          as required by your state.
          See our 
          <a href="https://www.legalzoom.com/legal/product-service-terms/supplemental-terms-of-service-for-corporate-center" target="_blank">Registered Agent Terms</a> 
          and 
          <a href="https://www.legalzoom.com/legal/product-service-terms/supplemental-terms-of-service-for-advantage-subscriptions" target="_blank">Subscription Terms</a> 
          for details.
        </div>

        <div id="legal-protect-disclaimer" class="mt-4 caption-1" *ngIf="hasSmartEmployer || hasLegalProtect">
          After your 10-day trial ends, you'll get automatically charged {{ showWIPrice ? '$15.99' : '$39.99' }}/month to continue {{ hasSmartEmployer ? 'Smart Employer' : 'Legal Protect' }}.
          The service auto-renews monthly and will be billed to your card on file.
          Go online or call (888) 310-0151 to cancel.
          Attorney services are fulfilled through Business Advantage Pro.
          See our 
          <a href="https://www.legalzoom.com/legal/product-service-terms/legal-plan-contract" target="_blank">Legal Plan Contract Terms</a> and 
          <a href="https://www.legalzoom.com/legal/product-service-terms/supplemental-terms-of-service-for-advantage-subscriptions" target="_blank">Subscription Terms</a> 
          for details.
        </div>

        <div id="total-compliance-disclaimer" class="mt-4 caption-1" *ngIf="hasTotalCompliance">
          After your 10-day trial ends, you'll get automatically charged $280/year to continue Total Compliance.
          The service auto-renews annually and will be billed to your card on file.
          Go online or call (888) 310-0151 to cancel. See our 
          <a href="https://www.legalzoom.com/legal/product-service-terms/supplemental-terms-of-service-for-advantage-subscriptions" target="_blank">Subscription Terms</a>  
          for details.
        </div>

        <div id="g-suite-disclaimer" *ngIf="gsuiteOrder && gsuiteOrder.ExpressOrderId" class="mt-4 caption-1">
          You are purchasing a monthly subscription that renews automatically on the 1st of each month.
          Renewal rates subject to change.
          You can cancel renewals anytime by visiting your LegalZoom account.
        </div>
      </div>
    </div>

  </div>
</div>
